module.exports = function(posts) {
	"use strict";
  posts
  .controller('categoriesController', categoriesController)
	categoriesController.$inject = ["watchAllCheckboxesNgTable","slugifyValidator","keyPressSlugify","checkArray","$stateParams","$state","$scope","$rootScope","NgTableParams", "getDataService","refreshtokenService","$filter","postDataService","alertService","reqursiveService","jQuery","deleteDataService","putDataService","serverError","comunicateBetweenViews","offlineError"]
	
  function categoriesController(watchAllCheckboxesNgTable,slugifyValidator,keyPressSlugify,checkArray,$stateParams,$state,$scope,$rootScope, NgTableParams,getDataService,refreshtokenService,$filter,postDataService,alertService,reqursiveService,jQuery, deleteDataService,putDataService,serverError, comunicateBetweenViews,offlineError) {
    var vmc = this;
    var state = 'categories';
    var $data;
    var s;
    var search;
    var tree = 1;
    vmc.categoryEdit = false;
    $rootScope.alert={hasBeenShown: false};
    $rootScope.hasLoaded = false;
    vmc.selectedName = -1;
    vmc.nameRequired = false;
    vmc.hasParent = {items:{}};
    vmc.categoryName = undefined;
    vmc.categorySlug = undefined;
    vmc.categoryDescription= undefined;
    vmc.selectedBulkAction = {value: 'default'};
    vmc.checkedPostsEdit = [];
    vmc.checkboxes = { 'checked': false, items: {}};
    vmc.categoryId = $stateParams.id; 
    if($stateParams.id) {
      vmc.categoryEdit = true;
    } else {
      vmc.categoryEdit = false;
    }
    vmc.slugValid = true;
    vmc.keyPressSlugify = keyPressSlugify;
    vmc.categorySlugValidate = function(value) {
      vmc.slugValid = true;
      if(value) {
        vmc.slugValid = slugifyValidator(value);
      }
    }
    // add new category
    vmc.addNewCategory = function() {
      if(!vmc.slugValid) return;
      if(vmc.selectedCategory.value =='none') {
        vmc.selectedCategory.value = undefined;
      }
      if(vmc.categoryName) {
        var postFunction = function() {  
          postDataService.save({
            param1:'categories', 
            param2: 'create'
          },{
            'name':vmc.categoryName,
            'parent': vmc.selectedCategory.value,
            "description": vmc.categoryDescription,
            'slug':vmc.categorySlug
          }).$promise.then(function(postCategory){
            vmc.categoryName = undefined;
            vmc.categorySlug = undefined;
            vmc.categoryDescription= undefined;
            vmc.selectedCategory.value ='none';
            alertService('success','Success ', postCategory.message, 2000);
            vmc.searchData ={name:''};
            vmc.getCategories();
          }, function(error){
            if(!window.navigator.onLine) {
              offlineError()
              alertService('danger','Opps! ', 'Please check your internet connection and try again.');
              return
            }
            if(error.status ==401) {
              var promise = refreshtokenService.getAccessToken();
              promise.then(
                function(answer) {
                  if(answer==200) {   
                    postFunction();
                  }
                },
                function(error) {
                },
                function(progress) {
                 // report progress
              });
            } else if(error.status ==502) {
              serverError()
            } else {
              alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
              if(error && error.data && error.data.error && error.data.error.slug) {
                vmc.categorySlug = error.data.error.slug;
              }
              vmc.selectedCategory.value ='none';
            } 
          });
        }
        postFunction();
      } else {
        vmc.selectedCategory.value ='none';
        alertService('danger','Opps! ', 'Category name is required')
        vmc.nameRequired=true;
      }
    }
    vmc.editCategory = function(categoryId) {
      vmc.categoryEdit= true;
      jQuery("html, body").animate({
        scrollTop: 0
      }, 10);
      vmc.categoryId = categoryId;
      $state.transitionTo('app.categories', {id: vmc.categoryId}, {
        location: true,
        inherit: true,
        relative: $state.$current,
        notify: false
      });
    }
    vmc.quickEdit = function(id) {
      vmc.selectedName = id;
    }
    vmc.cancelQuickEdit = function() {
      vmc.selectedName = -1;
    }
    vmc.goToAllPosts = function(category) {
      comunicateBetweenViews.setCategory(category);
      $state.go('app.allposts'); 
    }
    vmc.updateBulkDeleteSuccess = function() {
      watchAllCheckboxesNgTable.resetCheckBox(vmc)
      vmc.selectedBulkAction = {value: 'default'};
      vmc.searchData = {name:''};
      vmc.getCategories('update'); 
    }
    watchAllCheckboxesNgTable.watch($scope,vmc)
    vmc.checkedPost = function(categoryId, checked) {
      if(checked) {
        vmc.checkedPostsEdit.push(categoryId);
      } else {

        if(vmc.checkedPostsEdit.includes(categoryId)) {
          var id_tag = categoryId;
          var position = vmc.checkedPostsEdit.indexOf(id_tag);
          vmc.checkedPostsEdit.splice(position, 1);
        }
      }
    }
    var tablePopulateFunction = function() {
      vmc.tableParams = new NgTableParams({
        page: 1,
        count: 20,
       
        }, {
          total:vmc.categoriesTreeInput.length,
        getData: function(params) {
          $data = vmc.categoriesTreeInput; 
          $data = params.sorting() ?
          $filter('orderBy')($data, params.orderBy()) : $data;
          $data = $data.slice((params.page() - 1) * params.count(), params.page() * params.count());
          vmc.dataGet = $data;
          jQuery('.goTo input').val("");
          watchAllCheckboxesNgTable.resetCheckBox(vmc)
          if(vmc.categoriesTreeInput.length == 0) {
              $rootScope.emptyTable = true;
            } else {
              $rootScope.emptyTable = false;
            } 
          return $data; 
        }    
      });  
    }
    vmc.dataCategoryFunction = function(update) {
      vmc.categoryTreeFunction= function() {
        vmc.categoriesTreeInput = reqursiveService.getReqursiveArray(vmc.data);
        vmc.copycategoriesTreeInput = angular.copy(vmc.categoriesTreeInput);
        vmc.categoriesTreeSelect = angular.copy(vmc.categoriesTreeInput);
        for(var i=0; i< vmc.categoriesTreeSelect.length; i++) {
          var n = (vmc.categoriesTreeSelect[i].ancestors.length)*2;
          var empty = "\u00A0";
          for(var j=0;j<n;j++) {
            vmc.categoriesTreeSelect[i].name = empty+vmc.categoriesTreeSelect[i].name;
          }
        }
      }
      vmc.categoryTreeFunction();
      vmc.selectedCategory= {value: 'none'};
      if(update) {
        vmc.tableParams.reload()
      } else {
        tablePopulateFunction()
      }
    }
    vmc.changeSearch = function(searchData) {
      vmc.categoriesTreeInput = (searchData.name)? reqursiveService.getReqursiveArray($filter('filter')(vmc.copycategoriesTreeInput,searchData)) : vmc.copycategoriesTreeInput; 
      vmc.categoriesTreeInput = checkArray.removeObjArryDuplicate(vmc.categoriesTreeInput)
      tablePopulateFunction()
    }
    vmc.getCategories = function(update) {
      $rootScope.hasLoaded = false;
      var getCategoriesFunction = function() {
        getDataService.get({param1:'categories', param2: null,tree:tree, showinvisible:true}).$promise.then(function(data){
          vmc.data = data.categories;
          vmc.dataCategoryFunction(update);
          $rootScope.hasLoaded = true;
        }, function(error){
          if(!window.navigator.onLine) {
            offlineError()
            $rootScope.hasLoaded = true;
            return
          }
          if(error.status ==401) {
            var promise = refreshtokenService.getAccessToken();
            promise.then(
              function(answer) {
                if(answer==200) {
                  getCategoriesFunction();
                }
              },
              function(error) {
              },
              function(progress) {
               // report progress
            });
          } else if(error.status ==502) {
            serverError()
          } else if(error.status ==404) {
            $rootScope.emptyTable = true;
          } else {
            alertService('danger','Opps! ', error.data.error.message);
          }
          $rootScope.hasLoaded = true;
        }); 
      }
      getCategoriesFunction();
    }
    vmc.getCategories();
    if(!window.navigator.onLine) {
      offlineError('refresh')
      return
    }
  }	
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/postsModule/categories/js/categoriesController.js
// module id = 550
// module chunks = 0